module.exports = __webpack_public_path__ + "static/img/appback2.763811d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/appback2.png
// module id = lw91
// module chunks = 0